import { Fragment } from "react";
import { Listbox, Transition } from "@headlessui/react";

import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";

export type ResourceOptionType = {
  id: string;
  title: string;
  filter: string;
};

interface FilterDropDownProps {
  name: string;
  label: string;
  resourceParam: string;
  selected: ResourceOptionType;
  options: ResourceOptionType[];
  handleResourceFilter: (val: string) => void;
}

export function FilterDropDown({
  name,
  label,
  selected,
  resourceParam,
  options,
  handleResourceFilter,
}: FilterDropDownProps) {
  return (
    <Listbox
      name={name}
      value={resourceParam}
      onChange={(val) => {
        handleResourceFilter(val);
      }}
    >
      <div className="mb-1">
        <label htmlFor={name} className="text-sm text-gray-500">
          {label}
        </label>
      </div>
      <div>
        <Listbox.Button className="grid w-full cursor-default grid-cols-1 shadow-sm rounded-md bg-white py-2 pl-3 pr-2 text-left text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary-600 sm:text-sm/6">
          <span className="col-start-1 row-start-1 truncate pr-6">
            {selected.title}
          </span>
          <span className="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4">
            <ChevronUpDownIcon
              className="h-5 w-5 text-gray-400"
              aria-hidden="true"
            />
          </span>
        </Listbox.Button>
        <Transition
          as={Fragment}
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Listbox.Options className="absolute z-10 max-h-60 w-64 overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm">
            {options.map((status) => (
              <Listbox.Option
                key={status.id}
                className={({ active }) =>
                  `relative cursor-default select-none py-2 pl-10 pr-4 ${
                    active ? "bg-primary-100 text-primary-900" : "text-gray-900"
                  }`
                }
                value={status.filter}
              >
                {({ selected }) => (
                  <>
                    <span
                      className={`block truncate ${
                        selected ? "font-medium" : "font-normal"
                      }`}
                    >
                      {status.title}
                    </span>
                    {selected ? (
                      <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-primary-600">
                        <CheckIcon className="h-5 w-5" aria-hidden="true" />
                      </span>
                    ) : null}
                  </>
                )}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </Transition>
      </div>
    </Listbox>
  );
}
